import { isChangePageUrl } from './isChangePageUrl';

/**
 * The `/path?query#hash` of a Change.org page URL, or `null` when `isChangePageUrl` rejects it.
 *
 * Use it for a redirect that leaves the browser's own navigation (an SSR `Location` header, an email
 * link, a request to another service). Parsers disagree on inputs like `https://www.change.org\\@evil.com`,
 * and the returned path has no host left to disagree about.
 */
export function getChangePagePath(url: string, { baseUrl }: { baseUrl: string }): string | null {
	if (!isChangePageUrl(url, { baseUrl })) {
		return null;
	}
	const { pathname, search, hash } = new URL(url, baseUrl);
	return `${pathname}${search}${hash}`;
}
